module.exports = __webpack_public_path__ + "img/ntc2.b3486f96.png";